import { Direction_Enum, Provider_Enum } from '@weave/schema-gen-ts/dist/schemas/fax/shared/v1/enums.pb';
import { FaxTypes } from '@frontend/api-fax';
import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';

const INITIAL_SELECTED_FAX_STATE: FaxTypes.SelectedFax = {
  faxId: '',
  mediaId: '',
  contactName: '',
  contactPhone: '',
  contactId: '',
  profileMediaId: '',
  profileMedia: '',
  locationId: '',
  locationPhone: '',
  locationPhoneDisplayName: '',
  direction: Direction_Enum.UNSPECIFIED,
  provider: Provider_Enum.UNSPECIFIED,
  status: '',
  isArchived: false,
  isBlocked: false,
  tags: [],
  thumbnailIds: [],
  pages: 0,
};

interface SelectedFaxStore {
  selectedFax: FaxTypes.SelectedFax;
  setSelectedFax: (val: FaxTypes.SelectedFax) => void;
  resetSelectedFax: () => void;
}

export const useSelectedFaxStore = createStoreWithPersistAndSubscribe<SelectedFaxStore>(
  (set) => ({
    selectedFax: INITIAL_SELECTED_FAX_STATE,
    setSelectedFax: (args: FaxTypes.SelectedFax) =>
      set(
        (state) => {
          state.selectedFax = { ...state.selectedFax, ...args };
        },
        false,
        'SET_SELECTED_FAX'
      ),
    resetSelectedFax: () => {
      set(
        (state) => {
          state.selectedFax = { ...INITIAL_SELECTED_FAX_STATE };
        },
        false,
        'RESET_SELECTED_FAX'
      );
    },
  }),
  { name: 'SelectedFaxStorage', version: 2 },
  { name: 'SelectedFax', trace: true }
);

export const useSelectedFaxShallowStore = createShallowStore(useSelectedFaxStore);
